<template>
  <div class="demo-warning-message">
    <p class="demo-text">
      This is a demo screener, please be aware no answers will be recorded.<br />
      To quit the demo
      <span class="demo-link" @click="returnToHome">Click Here</span>
    </p>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: 'exit-demo'): void
}>()

const returnToHome = () => {
  emit('exit-demo')
}
</script>

<style scoped lang="scss">
.demo-warning-message {
  .demo-text {
    color: $danger;
    text-align: center;
  }
  .demo-link {
    cursor: pointer;
    font-weight: bold;
  }
}
</style>
